import React from 'react';
import styles from './LoadingTimeline.module.scss';

const LoadingTimeline = () => {
  return (
    <div className={styles['container']}>
      <div className={styles['icon-wrapper']}>
        <img src="/images/icons/loading.png" alt="icon-loading" />
      </div>
      <p className={styles['loading-text']}>Loading Data</p>
    </div>
  );
};

export default LoadingTimeline;
